/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_View_CardsInputs */

const cs_gallery_view_cards = /** @type {(inputs: Gallery_View_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karty`)
};

const en_gallery_view_cards = /** @type {(inputs: Gallery_View_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cards`)
};

/**
* | output |
* | --- |
* | "Cards" |
*
* @param {Gallery_View_CardsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_view_cards = /** @type {((inputs?: Gallery_View_CardsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_View_CardsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_view_cards(inputs)
	return cs_gallery_view_cards(inputs)
});